import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import { useApi } from "../../../context/api.js";
import { closeCreateList, useHomework } from "../../../context/homework";
import MDTypography from "../../../components/MDTypography";
import { formatDate } from "../../../utils/date.js";
import Grid from "@mui/material/Grid";
import MDBox from "../../../components/MDBox";
import MDInput from "../../../components/MDInput";

function CreateHomeworkListDialog() {
  const [homework, dispatch] = useHomework();
  const api = useApi();
  const [list, setList] = useState(null);

  useEffect(() => {
    if (homework.createList) {
      if (homework.createList.from) {
        // New list for child
        api.getChild(homework.createList.from).then((res) => {
          if (res && res.class) {
            setList({ class: res.class });
          } else {
            closeCreateList(dispatch);
          }
        });
      } else if (homework.createList.list) {
        // Load list for edition
        api.getList(homework.createList.list).then((res) => {
          setList(res);
        });
      }
    }
  }, [homework.createList]);

  const isValid = () => {
    return list && list.end;
  };

  const handleSave = () => {
    const toSave = {
      ...list,
    };
    api.saveList(toSave).then((res) => {
      if (res) {
        // TODO : list duplication + progress bar for list duplication
        closeCreateList(dispatch);
      } else {
        // TODO : Display error
      }
    });
  };

  return (
    <Dialog
      open={!!homework.createList}
      onClose={() => closeCreateList(dispatch)}
      maxWidth="md"
      fullWidth
    >
      {list === null && (
        <DialogContent sx={{ textAlign: "center" }}>
          <CircularProgress color="info" />
        </DialogContent>
      )}
      {!!list && (
        <>
          {/*<DialogTitle>{h.name}</DialogTitle>*/}
          <DialogContent>
            {/*<DialogContentText>{h.description}</DialogContentText>*/}
            <MDTypography variant="h5" component="div" sx={{ mb: list.end ? 0 : 1.5 }}>
              {list.id ? "Modification" : "Ajout"} d&apos;une liste de devoirs - {list.class.name}
            </MDTypography>
            {list.end && (
              <MDTypography
                sx={{
                  mb: 1.5,
                  fontStyle: "italic",
                  fontSize: 12,
                  color: new Date(list.end + "T23:59:59") <= new Date() ? "red" : undefined,
                }}
                color="text"
              >
                Devoirs à faire jusqu&apos;au {formatDate(list.end)}
              </MDTypography>
            )}
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <MDBox>
                  <MDInput
                    type="date"
                    label="Valide du"
                    name="start"
                    InputLabelProps={{ shrink: true }}
                    value={list.start || null}
                    onChange={(e) => setList({ ...list, start: e.target.value })}
                    fullWidth
                  />
                  <MDTypography
                    variant="caption"
                    sx={{ fontStyle: "italic", lineHeight: "1.5", mt: 0.25 }}
                    component="div"
                  >
                    Début de validité de la liste de devoirs. Valide immédiatement si non spécifié.
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MDBox>
                  <MDInput
                    type="date"
                    label="À terminer pour le"
                    required
                    name="end"
                    InputLabelProps={{ shrink: true }}
                    value={list.end || null}
                    onChange={(e) => setList({ ...list, end: e.target.value })}
                    fullWidth
                  />
                  <MDTypography
                    variant="caption"
                    sx={{ fontStyle: "italic", lineHeight: "1.5", mt: 0.25 }}
                    component="div"
                  >
                    Fin de la validité de la liste de devoirs.
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button disabled={!list} onClick={() => closeCreateList(dispatch)}>
              Fermer
            </Button>
            <Button disabled={!list || !isValid()} color="info" onClick={handleSave}>
              Sauvegarder
            </Button>
          </DialogActions>
        </>
      )}
      <IconButton
        aria-label="close"
        onClick={() => closeCreateList(dispatch)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
}

export default CreateHomeworkListDialog;
